var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 444.614,
    height: 386.621,
    viewBox: "0 0 444.614 386.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(-824 1284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_53_x2C__Cloud_x2C__Computing_x2C__Synchronize_x2C__Upload",
    transform: "translate(824 -1284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M401.165,183.442a86.99,86.99,0,0,0-122.043-61.263,106.346,106.346,0,0,0-201.39,66.912,87.005,87.005,0,0,0,35.257,166.54h39.143a96.658,96.658,0,0,0,192.347,0h39.144a86.988,86.988,0,0,0,17.541-172.189ZM248.307,423.29a77.324,77.324,0,1,1,77.324-77.324A77.412,77.412,0,0,1,248.307,423.29ZM383.624,336.3H344.48a96.658,96.658,0,0,0-192.347,0H112.99A67.666,67.666,0,0,1,92.551,204.131a9.667,9.667,0,0,0,6.182-12.474,87.01,87.01,0,1,1,165.694-52.831,9.669,9.669,0,0,0,14.595,5.487A67.632,67.632,0,0,1,383.138,193a9.666,9.666,0,0,0,8.472,8.472,67.651,67.651,0,0,1-7.986,134.83Z",
    transform: "translate(-26 -56)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M185.666,96a9.666,9.666,0,1,0,0,19.331,57.605,57.605,0,0,1,49.714,28.111,9.665,9.665,0,0,0,16.557-9.977A76.784,76.784,0,0,0,185.666,96Z",
    transform: "translate(-31.017 -57.338)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M7.7,86.011a7.912,7.912,0,0,0,11.187,0l27.97-27.97,27.97,27.97A7.911,7.911,0,1,0,86.012,74.823L58.042,46.854l27.97-27.97A7.911,7.911,0,1,0,74.823,7.7L46.854,35.667,18.884,7.7A7.911,7.911,0,1,0,7.7,18.885L35.667,46.854,7.7,74.824A7.912,7.912,0,0,0,7.7,86.011Z",
    transform: "translate(175.453 246.126)",
    fill: "#bfbfbf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictUpload);
export default __webpack_public_path__ + "static/media/restrict_upload.eeb5f1a16ec14dce8789f9344907343e.svg";
export { ForwardRef as ReactComponent };